import type { OrganizationLite } from "@/entities/organization";
import type { UseListOptions } from "@/hooks/queries";

import { useList } from "@/hooks/queries";

export const useGetOrganizations = (
  options?: UseListOptions<OrganizationLite>
) => {
  const { data, ...queryResult } = useList<OrganizationLite>(
    "organizations",
    options
  );

  return {
    organizations: data?.data ?? [],
    ...queryResult,
  };
};
